import { render, staticRenderFns } from "./DispatchRowActions.vue?vue&type=template&id=2c9d75a9&scoped=true&"
import script from "./DispatchRowActions.vue?vue&type=script&lang=js&"
export * from "./DispatchRowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d75a9",
  null
  
)

export default component.exports